import './vscode-services/extHost.js';
export { default as Severity } from 'monaco-editor/esm/vs/base/common/severity.js';
export { StorageScope, StorageTarget } from './vscode/vs/platform/storage/common/storage.js';
import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
import { Extensions } from './vscode/vs/workbench/common/contributions.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
export { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { ILifecycleService } from './vscode/vs/workbench/services/lifecycle/common/lifecycle.js';
import { RunOnceScheduler, runWhenIdle } from 'monaco-editor/esm/vs/base/common/async.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import getServiceOverride from './service-override/layout.js';
export { ICommandService } from 'monaco-editor/esm/vs/platform/commands/common/commands.js';
export { INotificationService, NeverShowAgainScope, NoOpNotification, NoOpProgress, NotificationPriority, NotificationsFilter } from 'monaco-editor/esm/vs/platform/notification/common/notification.js';
export { IBulkEditService } from 'monaco-editor/esm/vs/editor/browser/services/bulkEditService.js';
export { ICodeEditorService } from 'monaco-editor/esm/vs/editor/browser/services/codeEditorService.js';
export { ILanguageService } from 'monaco-editor/esm/vs/editor/common/languages/language.js';
export { ILanguageConfigurationService } from 'monaco-editor/esm/vs/editor/common/languages/languageConfigurationRegistry.js';
export { IEditorWorkerService } from 'monaco-editor/esm/vs/editor/common/services/editorWorker.js';
export { ILanguageFeaturesService } from 'monaco-editor/esm/vs/editor/common/services/languageFeatures.js';
export { IModelService } from 'monaco-editor/esm/vs/editor/common/services/model.js';
export { ITextModelService } from 'monaco-editor/esm/vs/editor/common/services/resolverService.js';
export { IClipboardService } from 'monaco-editor/esm/vs/platform/clipboard/common/clipboardService.js';
export { IDialogService } from 'monaco-editor/esm/vs/platform/dialogs/common/dialogs.js';
export { IFileService } from 'monaco-editor/esm/vs/platform/files/common/files.js';
export { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
export { IMarkerService } from 'monaco-editor/esm/vs/platform/markers/common/markers.js';
export { IOpenerService } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
export { IProductService } from 'monaco-editor/esm/vs/platform/product/common/productService.js';
export { IQuickInputService } from 'monaco-editor/esm/vs/platform/quickinput/common/quickInput.js';
export { ITelemetryService } from 'monaco-editor/esm/vs/platform/telemetry/common/telemetry.js';
export { IUriIdentityService } from 'monaco-editor/esm/vs/platform/uriIdentity/common/uriIdentity.js';
export { IEditorGroupsService } from './vscode/vs/workbench/services/editor/common/editorGroupsService.js';
export { IEditorService } from './vscode/vs/workbench/services/editor/common/editorService.js';
export { IWorkbenchEnvironmentService } from './vscode/vs/workbench/services/environment/common/environmentService.js';
export { IHostService } from './vscode/vs/workbench/services/host/browser/host.js';
export { ILanguageStatusService } from './vscode/vs/workbench/services/languageStatus/common/languageStatusService.js';
export { IPaneCompositePartService } from './vscode/vs/workbench/services/panecomposite/browser/panecomposite.js';
export { IPathService } from './vscode/vs/workbench/services/path/common/pathService.js';
export { ITextFileService } from './vscode/vs/workbench/services/textfile/common/textfiles.js';
export { IWorkingCopyFileService } from './vscode/vs/workbench/services/workingCopy/common/workingCopyFileService.js';
export { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
export { IThemeService } from 'monaco-editor/esm/vs/platform/theme/common/themeService.js';
export { ISnippetsService } from './vscode/vs/workbench/contrib/snippets/browser/snippets.js';
export { IWorkspaceContextService } from 'monaco-editor/esm/vs/platform/workspace/common/workspace.js';
export { IStorageService } from 'monaco-editor/esm/vs/platform/storage/common/storage.js';
export { IAudioCueService } from 'monaco-editor/esm/vs/platform/audioCues/browser/audioCueService.js';
export { IDebugService } from './vscode/vs/workbench/contrib/debug/common/debug.js';
export { ILogService, ILoggerService, LogLevel } from 'monaco-editor/esm/vs/platform/log/common/log.js';
export { IViewsService } from './vscode/vs/workbench/common/views.js';
export { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
const serviceInitializeParticipants = [];
function registerServiceInitializeParticipant(participant) {
    serviceInitializeParticipants.push(participant);
}
async function initServices(overrides) {
    const instantiationService = StandaloneServices.initialize({
        ...getServiceOverride(),
        ...overrides
    });
    await instantiationService.invokeFunction(async (accessor) => {
        const lifecycleService = accessor.get(ILifecycleService);
        await Promise.all(( serviceInitializeParticipants.map(participant => participant(accessor))));
        lifecycleService.phase = 2 ;
    });
    return instantiationService;
}
const renderWorkbenchEmitter = new Emitter();
const onRenderWorkbench = renderWorkbenchEmitter.event;
async function initialize(overrides) {
    const instantiationService = await initServices(overrides);
    instantiationService.invokeFunction(accessor => {
        const lifecycleService = accessor.get(ILifecycleService);
        ( Registry.as(Extensions.Workbench)).start(accessor);
        renderWorkbenchEmitter.fire(accessor);
        lifecycleService.phase = 3 ;
        const eventuallyPhaseScheduler = new RunOnceScheduler(() => {
            runWhenIdle(() => {
                lifecycleService.phase = 4 ;
            }, 2500);
        }, 2500);
        eventuallyPhaseScheduler.schedule();
    });
}
export { initialize, onRenderWorkbench, registerServiceInitializeParticipant };
